<template>
    <v-card width="100%" elevation="0" color="transparent" :to="`/shop/products/${product._id}`" class="overflow-visible">
        <v-responsive width="100%" aspect-ratio="1">
            <v-sheet width="100%" height="100%" outlined class="d-flex align-center">
                <v-img :src="product.thumb" max-width="500" contain :aspect-ratio="3 / 2"></v-img>
            </v-sheet>
        </v-responsive>

        <div class="text-center mt-14px px-10px">
            <div>
                <div class="font-size-16 font-size-md-18 font-weight-medium text-truncate">{{ product.name }}</div>
            </div>

            <div class="mt-4px">
                <v-row no-gutters align="center" justify="center" class="font-size-14 grey--text text--darken-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                    <v-col cols="auto" class="d-flex">
                        <span class="text-truncate">{{ product.writer }}</span>
                        <v-divider v-if="product.writer && product.publisher" vertical class="mx-8px" style="max-height: 10px; min-height: 10px" />
                        <span class="text-truncate">{{ product.publisher }}</span>
                    </v-col>
                </v-row>
            </div>

            <div class="mt-4px">
                <div class="font-size-16">
                    <b class="primary--text">{{ product.salePrice.format() }}</b>원
                </div>
            </div>
        </div>
    </v-card>
</template>
<script>
export default {
    props: {
        product: { type: Object },
    },
};
</script>